import "./News.css";

import * as React from "react";

export default class News extends React.Component {

    private proAnimaFacebookLink = "https://www.facebook.com/proanimahaltern/posts/1454543827986803";
    private proAnimaFacebookLink2018 = "https://www.facebook.com/proanimahaltern/posts/1877028032405045";

    public render() {

        const linkToBookStore = (
            <a href="https://www.kortenkamp.de/" target="_blank">Buchhandlung Kortenkamp</a>
        );
        const linkToLibrary = (
            <a href="https://www.facebook.com/Stadtbuecherei.Haltern/" target="_blank">Bücherei</a>
        );

        const linkToBiermanns = (
            <a href="http://www.biermanns-im-caspers.de/" target="_blank">Biermanns</a>
        );

        return (
            <div className="News">
                <div className="News__title"><span>AKTU</span>ELLES</div>

                <div>
                    <h3>13.09.2019, Autorenlesung "als sei nichts"</h3>
                    <p>
                        Wir treten am 13. September wieder bei einer Lesung in der Stadtbücherei Haltern auf. Dieses
                        Mal liest zuerst Dr. Christian Kloß aus seinem Buch "als sei nichts". Danach sind wir dran,
                        wir freuen uns wie jedes Jahr sehr!
                    </p>
                    <a href="assets/images/leseabend.png" target="_blank">
                        <img src="assets/images/leseabend.png"/>
                    </a>
                </div>

                <div>
                    <h3>13.12.2018, "Einschließen und Genießen"</h3>
                    <p>
                        Im vorweihnachtlichen Haltern am See ließen wir uns in der gemütlichen
                        {linkToBookStore} einschließen und sangen für die Mitarbeiter des örtlichen
                        {linkToLibrary}-Teams.<br/>
                        Was für ein schöner Abend mit Euch!
                    </p>
                    <a href="assets/images/weihnachtsbuch.jpeg" target="_blank">
                        <img src="assets/images/weihnachtsbuch.jpeg"/>
                    </a>
                </div>

                <div>
                    <h3>08.12.2018, Weihnachten im Biermanns im Casper's</h3>
                    <p>
                        Bei Barbaras Geburtstagsfeier sangen wir im {linkToBiermanns} neben dem festlich
                        geschmückten Weihnachtsbaum nicht nur für ihre, sondern auch für die anderen
                        (Café-)Gäste, die so unverhofft zum Brunch auch Herzweg kennenlernten.<br/>
                        Herzlichen Glückwunsch,<br/>
                        liebste Barbara!
                    </p>
                    <a href="assets/images/weihnachtskeyboard.jpeg" target="_blank">
                        <img src="assets/images/weihnachtskeyboard.jpeg" style={{ width: 300 }}/>
                    </a>
                </div>

                <div>
                    <h3>10.10.2018, Und das Einhorn flog hoch</h3>
                    <p>
                        Wir sind begeistert und zutiefst berührt
                        von <a href="https://www.monterosa-verlag.de/" target="_blank">Claudia Gliemanns</a> Lesung
                        und dem wunderschönen Konzert mit Euch.<br/>
                        Vielen Dank ♥<br/>
                        ...auch nochmal an das Team
                        von <a href={this.proAnimaFacebookLink2018} target="_blank">pro anima</a>!
                    </p>
                    <a href="assets/images/pro_anima_2018.jpg" target="_blank">
                        <img src="assets/images/pro_anima_2018.jpg"/>
                    </a>
                </div>

                <div>
                    <h3>09.10.2018, Seelenschnupfen und Fliegende Einhörner</h3>
                    <p>
                        Wir dürfen am 9. Oktober wieder in der Stadtbücherei Haltern auftreten.
                        Dieses Mal haben unsere Freunde von pro anima die Autorin Claudia Gliemann eingeladen. Sie
                        liest aus ihrem Kinderbuch <i>Papas Seele hat Schnupfen</i>.<br/>
                        Wir freuen uns nicht nur auf unseren Auftritt und die Lesung, sondern auch auf das
                        Gespräch mit Euch über die Inhalte unserer Texte.
                    </p>
                    <a href="assets/images/flyer_pro_anima_2018_10_09.jpg" target="_blank">
                        <img src="assets/images/flyer_pro_anima_2018_10_09.jpg" style={{ width: 300 }}/>
                    </a>
                </div>

                <div>
                    <h3>09.2018, Gefühle zwischen Text und Ton</h3>
                    <p>
                        Im September trafen wir uns im Trigon in Haltern mit der U-30-Gruppe des Sozialpsychiatrischen
                        Dienstes Recklinghausen. Wir hatten einen sehr schönen Abend zwischen Musik und inspirierenden
                        Gesprächen über das Erwachsenwerden und den Mut zu Veränderung.
                    </p>
                    <a href="assets/images/2018-09-u30.png" target="_blank">
                        <img src="assets/images/2018-09-u30.png"/>
                    </a>
                </div>

                <div>
                    <h3>31.08.2018, Sommerfest der Wohnstätte Coerde</h3>
                    <p>
                        In fröhlicher Atmosphäre feierten wir gemeinsam mit den liebeswerten Bewohnern, Angestellten
                        und Nachbarn der Wohnstätte Coerde deren 20-jähriges Jubiläum.
                    </p>
                    <a href="assets/images/sommerfest.jpg" target="_blank">
                        <img src="assets/images/sommerfest.jpg" style={{ transform: "rotate(0.5turn)" }}/>
                    </a>
                </div>

                <div>
                    <h3>25.08.2018, Wohnzimmerkonzert</h3>
                    <p>
                        Lieber Johannes, nochmal herzlichen Glückwunsch zum Geburtstag. Es war sehr schön mit Dir
                        und Deinen Gästen. Dein Baumhaus werden wir nie vergessen.
                    </p>
                    <a href="assets/images/johannes.jpeg" target="_blank">
                        <img src="assets/images/johannes.jpeg"/>
                    </a>
                </div>

                <div>
                    <h3>23.10.2017. Lieber Mats, Dein Papa hat 'ne Meise – und wir Premiere</h3>
                    <a href="assets/images/pro_anima.jpg" target="_blank">
                        <img src="assets/images/pro_anima.jpg"/>
                    </a>
                    <p>
                        Liebes Veranstaltungsteam, lieber Sebastian, liebes Premierenpublikum,<br/>
                        wir hatten einen fantastischen Abend und hätten uns keinen schöneren
                        Ort für unseren ersten öffentlichen Auftritt wünschen können!<br/>
                        <a href={this.proAnimaFacebookLink} target="_blank">Link</a>
                    </p>
                </div>

                <div>
                    <h3>18.10.2017, 19.00, Stadtbücherei Haltern</h3>
                    <p>
                        Wir dürfen die Lesung von Sebastian Schlösser begleiten, der sein Buch
                        "Lieber Mats, Dein Papa hat 'ne Meise" vorstellen wird. Veranstalter sind
                        die gemütliche Stadtbücherei Haltern und die netten und engagierten
                        Leute von pro anima.<br/>
                        Wir freuen uns sehr!<br/>
                    </p>
                    <a href="assets/images/flyer_pro_anima.jpeg" target="_blank">
                        <img src="assets/images/flyer_pro_anima.jpeg" style={{ width: 300 }}/>
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/News.tsx